import React from "react";

const Footer = () => (
  <footer className="text-center p-6 bg-zinc-950 text-gray-400">
    © {new Date().getFullYear()} Alvin Zondi. All rights reserved.
  </footer>
);

export default Footer;
